import React, { useEffect, useState, useRef } from 'react'
import VignetteBL from './VignetteBL';

// Inject script to enable video APi
VignetteBL.VignetteVideoApiScriptEnable();

const VignetteVideo = (props) => {

    const { videoId, className } = props;
    const videoRef = useRef(null);

    useEffect(() => {
        VignetteBL.injectVideo(videoId, videoRef.current);
    }, [videoId])

    return (
        <div className={`video-player-wrapper ${className}`} ref={videoRef} />
    )
}

export default VignetteVideo